import type React from 'react'

import { customPageRegistry, customPageSlugs } from './slugs.generated'

/**
 * Check if a given slug corresponds to a registered custom page
 */
export const isCustomPage = (slug: string): boolean => {
  return customPageSlugs.includes(slug)
}

/**
 * Get a static component for a custom page slug
 * Uses static imports for full SSR compatibility
 */
export const getCustomPageComponent = (slug: string): React.ComponentType<any> | null => {
  if (!isCustomPage(slug)) {
    return null
  }

  // Get the component directly from registry (static import)
  const Component = customPageRegistry[slug]
  return Component || null
}
